<script>
import { qrSecretComputed, qrSecretMethods } from '@state/qrCodeHelpers'
import Loading from '@views/_loading.vue'
export default {
  components: { Loading },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...qrSecretComputed,
    computedSrcQr() {
      return this.qrCode?.qr
    },
    computedTenkey() {
      return this.qrCode?.tenkey || ''
    },
    computedQrCodeSuccess() {
      return !this.qrCodeSuccess
    },
    computedLoading() {
      return this.getIsLoadingQrCode
    },
  },
  created() {
    const token = this.$route.query.token
    const secret = this.getSecret
    if (secret) {
      this.getQrCode({ token: token, secret })
    } else {
      this.getQrCode({ token: token, secret: '' })
    }
  },
  destroyed() {
    this.resetSecret()
  },
  methods: {
    ...qrSecretMethods,
  },
}
</script>

<template>
  <div>
    <Loading v-if="computedLoading" :loading="computedLoading" />
    <v-app v-else>
      <v-app-bar
        v-if="!this.$vuetify.breakpoint.xs"
        elevation="0"
        app
        color="transparent"
      />
      <v-main>
        <v-container
          fluid
          :class="
            `d-flex ${
              this.$vuetify.breakpoint.xs
                ? 'idoors-qr-secret'
                : 'align-center justify-center'
            }`
          "
        >
          <v-card
            color="#fff"
            :rounded="`${this.$vuetify.breakpoint.xs ? '' : 'xl'}`"
            class="px-md-6 px-sm-4 px-6 pb-14 border-card-blue margin_bottom_main_qr"
            :width="`${this.$vuetify.breakpoint.xs ? '100%' : '374'}`"
            elevation="8"
          >
            <v-img
              :src="require('@assets/images/idoors_logo_blue.png')"
              contain
              aspect-ratio="1.5"
              width="283"
              class="ma-auto"
            />
            <p
              v-if="computedQrCodeSuccess"
              class="red--text font-weight-bold custom_top_bottom_qr_code"
              >{{ $t('errorShowQrCode') }}</p
            >
            <div v-else>
              <v-img
                v-if="computedSrcQr"
                :src="computedSrcQr"
                contain
                aspect-ratio="1.5"
                class="ma-auto"
              />
              <p
                class="text-center font-weight-bold text-h3"
                :class="[computedSrcQr === '' ? 'customTextTenkey' : 'mt-13 ']"
              >
                {{ computedTenkey }}
              </p>
            </div>
          </v-card>
        </v-container>
        <BaseFooter />
      </v-main>
    </v-app>
  </div>
</template>

<style lang="scss">
@import '@design';
.idoors-qr-secret {
  height: 100%;
  padding: 0;
}
.border-card-blue {
  border: 2px solid #307fc0 !important;
}
.custom_top_bottom_qr_code {
  margin-top: 90px;
  margin-bottom: 100px !important;
}
.customTextTenkey {
  margin-top: 110px !important;
  margin-bottom: 120px !important;
}
.margin_bottom_main_qr {
  margin-bottom: 64px !important;
}
</style>
